module.exports = __webpack_public_path__ + "static/img/v35-webinar.e573abf3.png";